import { Buffer } from 'buffer';

// Polyfill Buffer for browser compatibility with Solana libraries
if (typeof window !== 'undefined') {
  window.Buffer = Buffer;
}

// Polyfill global for browser
if (typeof globalThis !== 'undefined' && typeof (globalThis as any).global === 'undefined') {
  (globalThis as any).global = globalThis;
}

// SharedWorker stub for browsers that don't support it (Safari, some mobile browsers)
// This prevents "SharedWorker is not defined" errors from third-party libraries
if (typeof window !== 'undefined' && typeof (window as any).SharedWorker === 'undefined') {
  (window as any).SharedWorker = class SharedWorkerStub {
    port = {
      start: () => {},
      close: () => {},
      postMessage: () => {},
      addEventListener: () => {},
      removeEventListener: () => {},
      onmessage: null,
      onmessageerror: null,
    };
    onerror: ((ev: ErrorEvent) => void) | null = null;
    constructor(_scriptURL: string | URL, _options?: WorkerOptions) {
      // No-op stub - SharedWorker functionality won't work but app won't crash
      console.debug('[Polyfill] SharedWorker not supported, using stub');
    }
  };
}
